// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-settings-page {
  padding: 24px;
  height: 100%;
}

.room-settings-section {
  margin-bottom: 32px;
}

.room-settings-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.room-settings-option-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.room-settings-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.room-settings-option:hover:not(:has(input:disabled)) {
  background-color: #f5f5f5;
  border-color: #999;
}

.room-settings-option:has(input:checked) {
  background-color: #e8e8e8;
  border-color: #666;
}

.room-settings-option:has(input:disabled) {
  opacity: 0.6;
  cursor: not-allowed;
}

.room-settings-option input[type="radio"] {
  margin-top: 2px;
  cursor: pointer;
}

.room-settings-option input[type="radio"]:disabled {
  cursor: not-allowed;
}

.room-settings-option-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.room-settings-option-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.room-settings-option-description {
  font-size: 12px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/SecurityPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".room-settings-page {\n  padding: 24px;\n  height: 100%;\n}\n\n.room-settings-section {\n  margin-bottom: 32px;\n}\n\n.room-settings-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.room-settings-option-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.room-settings-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.room-settings-option:hover:not(:has(input:disabled)) {\n  background-color: #f5f5f5;\n  border-color: #999;\n}\n\n.room-settings-option:has(input:checked) {\n  background-color: #e8e8e8;\n  border-color: #666;\n}\n\n.room-settings-option:has(input:disabled) {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.room-settings-option input[type=\"radio\"] {\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.room-settings-option input[type=\"radio\"]:disabled {\n  cursor: not-allowed;\n}\n\n.room-settings-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.room-settings-option-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.room-settings-option-description {\n  font-size: 12px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
